import { useState } from 'react';
// material
import { Container, Typography, Card, Tab, Box, Stack } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import PageHeader from '../components/smallComponents/PageHeader';
import ProjectTools from './ProjectTools';
import ToolsTableInProject from '../components/ToolsTableInProject';

// components

export default function ProjectToolsTabs() {
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="xl">
      <PageHeader title="Project Tools" />
      <Card>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange}>
              <Tab label="Project Tools" value="1" />
              <Tab label="Tools List" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <ProjectTools />
          </TabPanel> 
          <TabPanel value="2">
            <ToolsTableInProject />
          </TabPanel>
        </TabContext>
      </Card>
    </Container>
  );
}
